/**
 * Side-effect only: ensure console.errorNormalized is available.
 * Re-export from core (single source of truth).
 */
import '@korvo/core/lib/console-error-normalized';
